<template>
  <div class="row">
    <aside class="col-md-3 col-sm-12 cus-sidebar">
      <ResourceSidebar />
    </aside>
    <div v-if="isLoading" class="loader">
      <div class="wave-container">
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
      <p>Loading...</p>
    </div>

    <div v-if="!isLoading" id="content" class="col-md-9 col-sm-12">
      <div class="material-box bg-white">
        <div class="row content-row">
          <div class="col-md-12 top-title">
            <h3>Awards</h3>
          </div>
          <div class="col-md-12">
            <div class="p-b-10">
              <div class="row">
                <div class="col-md-12 box-detail m-b-12 awards">
                  <p v-html="caAwardContent.Content1"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 box-detail m-b-12">
                  <h3 class="blue-text">The {{ caAwardContent.Year }} Chiropractic Assistant of the Year is
                    {{ caAwardContent.AwardFirstName }} {{ caAwardContent.AwardLastName }}, {{ caAwardContent.Status }}.
                  </h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 box-detail m-b-12 awards">
                  <p v-html="caAwardContent.Content2"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="material-list video listing-links">
                    <!-- <p>Past winners, of the Chiropractic Assistant of the Year Award, include:</p> -->
                    <ul>
                      <li v-for="(reward, index) in caAwards" :key="index">{{ reward.AwardFirstName }}
                        {{ reward.AwardLastName }}, {{ reward.Status }} - {{ reward.Year }}</li>
                    </ul>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-12 box-detail m-b-20 awards">
                  <p v-html="dcAwardContent.Content3"></p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 box-detail m-b-12 awards">
                  <p v-html="dcAwardContent.Content1"></p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 box-detail m-b-12">
                  <h3 class="blue-text">The {{ dcAwardContent.Year }} Chiropractor of the Year is
                    {{ dcAwardContent.AwardFirstName }} {{ dcAwardContent.AwardLastName }}, {{ dcAwardContent.Status }}.
                  </h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 box-detail m-b-12 awards">
                  <p v-html="dcAwardContent.Content2"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="material-list video listing-links">
                    <!-- <p>Past winners, of the Chiropractor of the Year Award, include:</p> -->
                    <ul>
                      <li v-for="(award, i) in dcAwards" :key="i">{{ award.AwardFirstName }} {{ award.AwardLastName }},
                        {{ award.Status }} - {{ award.Year }}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 box-detail m-b-20 awards">
                  <p v-html="dcAwardContent.Content4"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end page-header -->
    </div>
  </div>
</template>
    
<script>
import userAPI from '../userApi';

import ResourceSidebar from './components/ResourceSidebar.vue';


export default {
  components: { ResourceSidebar },
  name: "Module",
  data() {
    return {
      isLoading: false,
      caAwards: {},
      caAwardContent: {},
      dcAwards: {},
      dcAwardContent: {}
    }
  },
  methods: {
    awardsforCA() {
      this.isLoading = true;
      userAPI.awardsforCA(res => {
        this.caAwardContent = res.data.data.award;
        this.caAwards = res.data.data.awards;
        this.isLoading = false;

      }, err => {
        console.log(err);
        this.isLoading = false;

      })
    },
    awardsforDC() {
      userAPI.awardsforDC(res => {
        this.dcAwardContent = res.data.data.award;
        this.dcAwards = res.data.data.awards;
        console.log(this.dcAwardContent.Content1);
      }, err => {
        console.log(err);
      })
    }
  },
  mounted() {
    this.awardsforCA();
    this.awardsforDC();
  },
}
</script>

<style>
@media (max-width: 550px) {
  .awards ol {
    margin-left: 0 !important;
  }
  .material-list.video.listing-links li {
    width: 100%
  }
}
</style>